// "{base} (N)" 패턴을 인식해 다음 번호의 복제 이름을 만든다.
// - 원본이 "foo" 이고 "foo"만 존재하면 → "foo (2)"
// - 원본이 "foo" 이고 "foo", "foo (2)"가 존재하면 → "foo (3)"
// - 원본이 "foo (3)" 이면 base "foo"의 최대 N+1 (최소 2) 반환
export function nextDuplicateName(sourceTitle, existingTitles) {
  const source = (sourceTitle || '').trim();
  if (!source) return '';

  const baseMatch = source.match(/^(.*?)\s*\((\d+)\)$/);
  const base = baseMatch ? baseMatch[1].trim() : source;
  if (!base) return source;

  const escaped = base.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const numbered = new RegExp(`^${escaped}\\s*\\((\\d+)\\)$`);

  let maxN = 0;
  for (const t of existingTitles || []) {
    if (!t) continue;
    if (t === base) {
      maxN = Math.max(maxN, 1);
      continue;
    }
    const m = t.match(numbered);
    if (m) {
      const n = parseInt(m[1], 10);
      if (!Number.isNaN(n)) maxN = Math.max(maxN, n);
    }
  }
  return `${base} (${Math.max(maxN, 1) + 1})`;
}
